import "glightbox/dist/css/glightbox.min.css";

import GLightbox from "glightbox";

const lightbox = GLightbox({
	selector: ".glightbox--facilities",
});
